// The detail view's Configuration tab doubles as the upgrade form. The list
// card and detail action bar deep-link into it with the newer version
// pre-selected; this module is the single source of truth for that contract so
// the param name/value can't drift between the link builders and the reader.
// The matching AngularJS route declares these same names in
// app/portainer/__module.js ('portainer.addons.addon').

const UPGRADE_PARAM = 'upgrade';
const UPGRADE_ENABLED = '1';
const CONFIGURATION_TAB = 'configuration';

/** Router params that open the Configuration tab with the upgrade intent set. */
export function buildUpgradeParams(id: string | undefined) {
  return { id, tab: CONFIGURATION_TAB, [UPGRADE_PARAM]: UPGRADE_ENABLED };
}

/** True when the tab was opened via an Upgrade action (vs. opened to review). */
export function isUpgradeRequested(params: { upgrade?: unknown }): boolean {
  return params.upgrade === UPGRADE_ENABLED;
}
